import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation ActionProductTaxProfileStatus(
    $input: ProductTaxProfileStatusActionInput!
  ) {
    actionProductTaxProfileStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfile {
        id
        productId
        state
        approvedAt
        approvedBy {
          id
        }
      }
    }
  }
  ${ErrorMessageInfo}
`;
